import { Component, OnInit } from '@angular/core';
import { BannerService } from '../../../services/banner/banner.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditBannerComponent } from '../edit-banner/edit-banner.component';
import { FileUploader } from 'ng2-file-upload';
import { DragulaService } from 'ng2-dragula';
import { APP_CONTS } from '../../../app.constants';
import { ImageResizeService } from '../../../services/image-resize.service';
import { ConfirmService } from '../../../services/confirm/confirm.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

import { Banner } from '../../../../model/class/Banner';
import * as _ from 'lodash';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { finalize } from 'rxjs/operators';

const TYPE_SLIDE = 'ENCUENTRALO_EN_SF';
@Component({
  selector: 'app-banner-encuentralos',
  templateUrl: './banner-encuentralos.component.html',
  styles: [],
  providers: [DragulaService]
})
export class BannerEncuentralosComponent implements OnInit {

  activos: Banner[] = [];
  inactivos: Banner[] = [];
  eliminados: Banner[] = [];

  page = 1;

  contIdsNuevos = -1;

  loaders = {
    image: false,
    form: false,
    edit: false
  };

  imageFormat = APP_CONTS.FILES.IMAGE_FORMAT_STR;

  public uploader: FileUploader = new FileUploader({
    allowedMimeType: APP_CONTS.FILES.IMAGE_FORMAT
  });

  public hasBaseDropZoneOver = false;
  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  constructor(
    private _bannerService: BannerService,
    private modalService: NgbModal,
    private dragulaService: DragulaService,
    private imageResizeService: ImageResizeService,
    private confirmService: ConfirmService,
    private toasts: ToastsManager
  ) {

    dragulaService.setOptions('bag-banners', {
    });

    dragulaService.dropModel.subscribe((value) => {
      this.emparejarOrden();
      this.onDropModel(value.slice(1));
    });
    dragulaService.removeModel.subscribe((value) => {
      this.onRemoveModel(value.slice(1));
    });
  }

  private onDropModel(args) {
    let [el, target, source] = args;
    // do something else
  }

  private onRemoveModel(args) {
    let [el, source] = args;
    // do something else
  }

  ngOnInit() {

    this._bannerService.getActivosPorTipo(TYPE_SLIDE)
      .subscribe(resp => {
        _.each(resp.data, (o) => {
          const banner = new Banner(o);
          this.activos.push(banner);
        });
        this.emparejarOrden();
      });

    this._bannerService.getDesactivosPorTipo(TYPE_SLIDE)
      .subscribe(resp => {
        _.each(resp.data, (o) => {
          const banner = new Banner(o);
          this.inactivos.push(banner);
        });
      });
  }

  emparejarOrden() {
    _.each(this.activos, (banner: Banner, index) => {
      banner.orden = index + 1;
      banner.esPublicado = true;
    });

    _.each(this.inactivos, (banner: Banner) => {
      banner.esPublicado = false;
    });
  }

  eliminar(banner: Banner) {

    this.confirmService.confirm('Eliminar', '¿Seguro que desea eliminar este Banner?')
      .then((resp) => {
        if (resp) {
          _.remove(this.activos, { 'id': banner.id });
          _.remove(this.inactivos, { 'id': banner.id });

          if (!banner.esNuevo) {
            this.eliminados.push(banner);
          }

          this.emparejarOrden();
        }
      });
  }

  editar(banner: Banner, publicado: boolean) {
    const clon: Banner = _.clone(banner);
    clon.esPublicado = publicado;
    const viewModal = this.modalService.open(EditBannerComponent, { size: 'lg', windowClass: 'modal-admin' });
    viewModal.componentInstance.banner = clon;
    this.loaders.edit = true;
    viewModal.result
      .then((newBanner: Banner) => {
        this.loaders.edit = false;

        newBanner.modificado = true;
        if (publicado) {
          const index = _.findIndex(this.activos, { 'id': newBanner.id });

          if (newBanner.esPublicado) {
            this.activos[index] = newBanner;
          } else {
            _.remove(this.activos, { 'id': newBanner.id });
            this.inactivos.push(newBanner);
          }
        } else {
          const index = _.findIndex(this.inactivos, { 'id': newBanner.id });

          if (newBanner.esPublicado) {
            _.remove(this.inactivos, { 'id': newBanner.id });
            this.activos.push(newBanner);
          } else {
            this.inactivos[index] = newBanner;
          }
        }
      }, (reason) => {
        this.loaders.edit = false;
      });
  }

  crearNuevo(event: any) {
    if (this.uploader.queue[this.uploader.queue.length - 1]) {
      const file = this.uploader.queue[this.uploader.queue.length - 1]._file;
      if (file) {
        this.loaders.image = true;
        const newBanner = new Banner({ id: this.contIdsNuevos, esPublicado: false, orden: 0, nuevaImagen: file, tipo: TYPE_SLIDE });

        let name = file.name.replace(/\_/g, ' ');
        name = name.replace(/-/g, ' ');
        name = name.substring(0, name.lastIndexOf('.'));

        newBanner.titulo = name;

        this.imageResizeService.resize([file], 500, 200)
          .subscribe((result) => {
            const reader = new FileReader();
            reader.onload = (e: any) => {
              newBanner.imagen = e.target.result;
            };
            reader.readAsDataURL(result);

            this.loaders.image = false;
            const viewModal = this.modalService.open(EditBannerComponent, { size: 'lg', windowClass: 'modal-admin' });
            viewModal.componentInstance.banner = newBanner;

            this.loaders.edit = true;
            viewModal.result
              .then((createBanner: Banner) => {
                this.loaders.edit = false;
                this.contIdsNuevos--;
                createBanner.esNuevo = true;

                if (createBanner.esPublicado) {
                  this.activos.push(createBanner);
                  this.emparejarOrden();
                } else {
                  this.inactivos.push(createBanner);
                }
              }, (reason) => {
                this.loaders.edit = false;
              });

          });
      }
    } else {
      console.log('Archivo no valido');
    }
  }

  guardarCambios() {
    this.loaders.form = true;
    const obsEliminar = [];
    const obsCrear = [];
    const obsModificar = [];

    let errorEliminar = [];
    let errorCrear = [];
    let errorModificar = [];

    const nuevosFinal = _.union(_.filter(this.activos, { 'esNuevo': true }), _.filter(this.inactivos, { 'esNuevo': true }));

    const modActivos = _.filter(this.activos, (o: Banner) => {
      if (!o.esNuevo && o.modificado) {
        return o;
      }
    });
    const modInactivos = _.filter(this.inactivos, (o: Banner) => {
      if (!o.esNuevo && o.modificado) {
        return o;
      }
    });

    const modificadosFinal = _.union(modActivos, modInactivos);

    const modOrdenActivos = _.filter(this.activos, (o: Banner) => {
      if (!o.esNuevo && !o.modificado) {
        return o;
      }
    });

    const modOrdenInactivos = _.filter(this.inactivos, (o: Banner) => {
      if (!o.esNuevo && !o.modificado) {
        return o;
      }
    });

    const modOrdenFinal = _.union(modOrdenActivos, modOrdenInactivos);

    /**
     * 1. Elimino.
     */

    _.each(this.eliminados, (banner) => {
      obsEliminar.push(this._bannerService.eliminar(banner.id));
    });

    /**
     * 2. Creo.
     */
    _.each(nuevosFinal, (banner: Banner) => {
      obsCrear.push(this._bannerService.crear(banner.getFormData()));
    });

    /**
     * 3. Modifico
     */
    _.each(modificadosFinal, (banner: Banner) => {
      obsModificar.push(this._bannerService.edit(banner.id, banner.getFormData()));
    });
    _.each(modOrdenFinal, (banner: Banner) => {
      obsModificar.push(this._bannerService.edit(banner.id, banner.getFormDataOrden()));
    });

    forkJoin(obsEliminar)
      .pipe(
        finalize(() => {
          forkJoin(obsCrear)
            .pipe(
              finalize(() => {
                forkJoin(obsModificar)
                  .pipe(
                    finalize(() => {

                      if (errorEliminar.length === 0 && errorCrear.length === 0 && errorModificar.length === 0) {
                        this.toasts.success('Cambios guardados');
                      } else {
                        let mensaje = '<ul>';

                        if (errorEliminar.length > 0) {
                          mensaje = mensaje + '<li>Han ocurrido problemas al eliminar los banners</li>';
                          console.error(errorEliminar);
                        }
                        if (errorCrear.length > 0) {
                          mensaje = mensaje + '<li>Han ocurrido problemas al crear los nuevos banners</li>';
                          console.error(errorCrear);
                        }
                        if (errorModificar.length > 0) {
                          mensaje = mensaje + '<li>Han ocurrido problemas al modificar banners</li>';
                          console.error(errorModificar);
                        }
                        mensaje = mensaje + '</ul>';

                        if (errorEliminar.length === 0 || errorCrear.length === 0 || errorModificar.length === 0) {
                          mensaje = mensaje + '<p>Las demás acciones se han realizado con éxito</p>';
                        }
                        this.toasts.warning(mensaje, 'Ups...', { enableHTML: true });
                      }

                      this.loaders.form = false;
                    }))
                  .subscribe((resp) => {
                  }, (errors) => {
                    errorModificar = errors;
                  });
              }))
            .subscribe((resp) => {
            }, (errors) => {
              errorCrear = errors;
            });
        }))
      .subscribe((resp) => {
      }, (errors) => {
        errorEliminar = errors;
      });
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/banner-encuentralos/banner-encuentralos.component.ts